import { css } from 'styled-components';

const styles = css`
  .outerCont {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding-left: 1px;
    padding-bottom: 30px;
  }
  .intcont {
    width: 200px;
  }

  .parent:nth-last-child(1) {
    ${(props) =>
      props.biaDrawerProducts.length % 2 !== 0
        ? ` margin-right:auto;
  margin-left:20px;`
        : ''}
  }
  .bia-atb {
    border-radius: 0px !important;
  }
  .bia-view-more {
    width: 80%;
    margin-bottom: 20px;
    border-radius: 6px;
  }
  .bia-view-more:focus {
    background-color: transparent;
  }
  .Modal-Header {
    top: 0;
    position: sticky;
    z-index: 100;
    min-height: 53px;
  }

  .modal-heading {
    display: flex !important;
    border-bottom: none;
    padding-bottom: 26px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    justify-content: center;
    height: auto;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 30px 0 20px;
    white-space: nowrap;
    @media ${(props) => props.theme.mediaQuery.medium} {
      height: auto;
      padding-top: 5px;
      justify-content: center;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      padding-top: 9px;
      text-align: center;
      justify-content: center;
    }
  }

  div.TCPModal__InnerContent.atb-innerContent {
    padding: 10px 10px 0px 0px;
    padding: 0px !important;
  }
  div.TCPModal__InnerContent.atb-innerContent .modal-heading {
    padding: 10px 10px 0px 0px;
    display: flex !important;
    justify-content: center !important;
  }

  .product-tile {
    width: 170px !important;
  }
  .modal-heading:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 51px;
    margin: auto;
    z-index: -1;
    background-color: ${(props) => props.theme.colors.CULTURED};
    bottom: 10px;
    left: -17px;
    padding-right: 17px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-right: 17px;
    }
  }
  .drawer-footer {
    width: 100%;
    justify-content: center;
    display: flex;
    padding-top: 20px;
    box-shadow: 0px 0px 6px rgb(0 0 0 / 22%);
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .drawer-footer {
      padding-bottom: 50px;
    }
    .outerCont {
      justify-content: center;
    }
  }
  @media screen and (max-width: 350px) {
    .outerCont {
      justify-content: center;
    }
  }
`;

export default styles;
